import { useTranslation } from "react-i18next";
import { FormControl, InputLabel, MenuItem, Select } from "@mui/material";
import { useSearchParams } from "react-router-dom";
import ClearableSelect from "./ClearableSelect";

export default function UserActiveAppointmentFilter({
  param = "withoutReservations",
  deleteParams = ["withoutReservations"],
}) {
  const options = [
    { value: "true", label: "UsersWithoutActiveAppointments" },
    { value: "false", label: "UsersWithActiveAppointments" },
  ];

  return (
    <ClearableSelect
      param={param}
      deleteParams={deleteParams}
      label="Appointments"
      options={options}
      testId="users.page.filters.appointments-select"
    />
  );
}
